import { Theme } from '@mui/material';

export const overRideTypography = (theme: Theme) => {
  return {
    ...theme.typography,
    h1: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: '117%',
    },
    h2: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '117%',
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '143%',
    },
    body2: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '137%',
    },
  };
};
